import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export const HEADER_MIN_HEIGHT = 36;

export default makeStyles((theme: MuiTheme) => ({
  tableContainer: {
    flexGrow: 1
  },
  tableBody: {
    ["& .MuiTableRow-root:nth-child(4n+2) .MuiTableCell-root," +
    " & .MuiTableRow-root:nth-child(4n+3) .MuiTableCell-root"]: {
      backgroundColor: "rgba(238, 238, 238, 0.25)"
    },
    ["& .MuiTableRow-root:nth-child(4n+4) .MuiTableCell-root," +
    " & .MuiTableRow-root:nth-child(4n+5) .MuiTableCell-root"]: {
      backgroundColor: theme.palette.common.white
    }
  },
  tableHead: {
    color: theme.palette.text.primary,
    minHeight: HEADER_MIN_HEIGHT
  },
  tableHeadCell: {
    height: 36,
    padding: "4px 0",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    "&:first-child": {
      textAlign: "left",
      padding: "4px 0 4px 16px"
    }
  },
  emptyDataHolder: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c3c3c3",
    borderBottom: "1px solid #eeeeee",
    fontSize: 14
  }
}));
